import { Engine1Proxy, RestApiProxy, SagasProxy } from 'com-gyf-webcore-servicehub';

let PermisoManager = function () {
    /**
     * 
     * @param {any} data
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function _updatePermisoFuncionalidadPuntual(dataDelete, dataCreate, sagasCallback, viewCallback) {
        let localValues = mapearPermisoFuncionalidad(dataDelete, dataCreate);
        ejecutarSagas(localValues, 'SAGA_MODIFICAR_PERMISO_FUNCIONALIDAD', sagasCallback, viewCallback);
    }

    function _updatePermisosMasivos(funcionalidades, permissions, sagasCallback, viewCallback) {
        let localValues = mapearPermisoFuncionalidadMasivos(funcionalidades, permissions);
        ejecutarSagas(localValues, 'SAGA_ASIGNAR_PERMISO_FUNCIONALIDAD_MASIVOS', sagasCallback, viewCallback);
    }

    /**
     * 
     * @param {any} data
     */
    function mapearPermisoFuncionalidad(dataDelete, dataCreate) {

        let localValues = { "FuncionalidadDeleteList": [], "FuncionalidadCreateList": [],};

        dataDelete.forEach((permisoFuncionalidad) => {
            localValues.FuncionalidadDeleteList.push({
                'PERFIL_ID': permisoFuncionalidad.PERFIL_ID,
                'PRODUCTO_ID': permisoFuncionalidad.PRODUCTO_ID,
                'CATEGORIA_ID': permisoFuncionalidad.CATEGORIA_ID,
                'PROGRAMA_ID': permisoFuncionalidad.PROGRAMA_ID,
                'FUNCION_ID': permisoFuncionalidad.FUNCION_ID
            });
        });

        dataCreate.forEach((permisoFuncionalidad) => {
            localValues.FuncionalidadCreateList.push({
                'PERFIL_ID': permisoFuncionalidad.PERFIL_ID,
                'PRODUCTO_ID': permisoFuncionalidad.PRODUCTO_ID,
                'CATEGORIA_ID': permisoFuncionalidad.CATEGORIA_ID,
                'PROGRAMA_ID': permisoFuncionalidad.PROGRAMA_ID,
                'FUNCION_ID': permisoFuncionalidad.FUNCION_ID
            });
        });

        return localValues;
    }

    function mapearPermisoFuncionalidadMasivos(funcionalidades, permissions) {

        let localValues = { "FuncionalidadCreateList": [], "PermisoCreateList": [], };

        funcionalidades.forEach((funcionalidad) => {
            localValues.FuncionalidadCreateList.push({
                'PERFIL_ID': funcionalidad.PERFIL_ID,
                'PRODUCTO_ID': funcionalidad.PRODUCTO_ID,
                'CATEGORIA_ID': funcionalidad.CATEGORIA_ID,
                'PROGRAMA_ID': funcionalidad.PROGRAMA_ID,
                'FUNCION_ID': funcionalidad.FUNCION_ID
            });
        });

        permissions.forEach((permiso) => {
            localValues.PermisoCreateList.push({
                'PRODUCTO_ID': permiso.PRODUCTO_ID,
                'CATEGORIA_ID': permiso.CATEGORIA_ID,
                'PROGRAMA_ID': permiso.PROGRAMA_ID,
                'FUNCION_ID': permiso.FUNCION_ID,
                'PERMISO': permiso.PERMISO,
                'USUARIO_ID': permiso.USUARIO_ID
            });
        });

        return localValues;
    }

    /**
     * 
     * @param {any} localValues
     * @param {any} saga
     * @param {any} sagasCallback
     * @param {any} viewCallback
     */
    function ejecutarSagas(localValues, saga, sagasCallback, viewCallback) {
        SagasProxy.AddSagaRequests(localValues, saga, "CONCIERGE", "SEGURIDAD");

        RestApiProxy.SetApiUrl();

        SagasProxy.Execute(sagasCallback, undefined, viewCallback, null, null, "SEGURIDAD");
    }

    return {
        UpdatePermisoFuncionalidadPuntual: function (dataDelete, dataCreate, sagasCallback, viewCallback) {
            return _updatePermisoFuncionalidadPuntual(dataDelete, dataCreate, sagasCallback, viewCallback);
        },
        UpdatePermisosMasivos: function (funcionalidades, permissions, sagasCallback, viewCallback) {
            return _updatePermisosMasivos(funcionalidades, permissions, sagasCallback, viewCallback);
        }
    }
};

let permisoManager = new PermisoManager();
export default permisoManager;